import { Spacing, Text, Title } from '@vkontakte/vkui';
import img from 'img/tooltip/sharing-onboarding-tooltip.png';
import React, { type RefObject, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './SharingOnboardingTooltip.css';

interface SharingOnboardingTooltipProps {
    forcePromo: boolean;
    target: RefObject<HTMLElement> | Element | null;
}

export const SHARING_ONBOARDING_TOOLTIP_ID = 'sharingOnboardingTooltipId';

export function SharingOnboardingTooltip({ target, forcePromo }: SharingOnboardingTooltipProps) {
    const dispatch = useDispatch();
    const [showTooltip, setShowTooltip] = useState(false);
    const storage = useSelector(getCurrentStorage);

    useEffect(() => {
        if (forcePromo) {
            setTimeout(() => setShowTooltip(forcePromo), 400); // таймаут чтоб не конфликтовало с анимацией появления окна шеринга
            dispatch(UserStorageActions.set(SHARING_ONBOARDING_TOOLTIP_ID, new Date().valueOf()));
        }
    }, [dispatch]);

    const onTooltipShow = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.ONBOARDING_TOOLTIP_SHOW, { source: 'header' });
        sendPaymentGa({
            action: 'show',
            eventCategory: ECategoryGa.tooltip,
            name: 'advanced_settings',
            place: storage,
        });
    }, []);

    const onTooltipClose = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.ONBOARDING_TOOLTIP_CLOSE, { source: 'header' });
        sendPaymentGa({
            action: 'close',
            eventCategory: ECategoryGa.tooltip,
            name: 'advanced_settings',
            place: storage,
        });
    }, []);

    return showTooltip ? (
        <FloatingTooltip
            contentClassName={styles.root}
            target={target}
            placement={ETooltipPlacement.right}
            qaId="sharing-onboarding-tooltip"
            withinModal
            closable
            closeOnOutsideClick
            usePortal
            onShow={onTooltipShow}
            onClose={onTooltipClose}
        >
            <div className={styles.tooltip}>
                <Title className={styles.tooltipTitle}>С&nbsp;подпиской можно больше</Title>
                <Spacing size={4} />
                <Text className={styles.tooltipText}>Попробуйте Mail Space&nbsp;&mdash; с&nbsp;ней настроек папки будет больше</Text>
                <img src={img} alt="С подпиской можно больше" className={styles.image} />
            </div>
        </FloatingTooltip>
    ) : null;
}
